<div  class="flex flex-col w-full gap-5 h-full min-h-screen-40 items-center justify-center bg-white bg-opacity-60 rounded-md">
    <lottie-player  src="/assets/lottie/s-loader.json" background="transparent" speed="1"
      style="width: 12rem; height: 12rem;" loop autoplay="false"></lottie-player>
  </div>